import React from 'react';

import { StyledReactMarkdown } from '@pkg/components';

import { SectionWrapper } from './styles';

interface PreviewProps {
    markdown: string;
    linkTarget?: '_blank' | '_self';
}
export const Preview = ({ markdown, linkTarget = '_blank' }: PreviewProps) => {
    return (
        <SectionWrapper>
            <StyledReactMarkdown linkTarget={linkTarget}>{markdown}</StyledReactMarkdown>
        </SectionWrapper>
    );
};
